import { API_PDC_URL_V2 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const paymentConstants = {
  REGISTER_TSPAY_DEADLINES_PAYMENT_START: "REGISTER_TSPAY_DEADLINES_PAYMENT_START",
  REGISTER_TSPAY_DEADLINES_PAYMENT_SUCCESS: "REGISTER_TSPAY_DEADLINES_PAYMENT_SUCCESS",
  REGISTER_TSPAY_DEADLINES_PAYMENT_ERROR: "REGISTER_TSPAY_DEADLINES_PAYMENT_ERROR"
};

export function registerDeadlinesPayment(deadlineIds, initDeadlinesPayId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuid = main.accountantUuidSelected;
    const companyUuid = main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: paymentConstants.REGISTER_TSPAY_DEADLINES_PAYMENT_START,
        payload: deadlineIds
      });

      let request = {
        method: "PATCH",
        url: `${API_PDC_URL_V2}/deadlines/registerPayment`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          itemId: companyUuid,
          managerId: accountantUuid,
          deadlineIds: deadlineIds,
          initDeadlinesPayId: initDeadlinesPayId
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: paymentConstants.REGISTER_TSPAY_DEADLINES_PAYMENT_SUCCESS,
            payload: { ...result.data, deadlines: [deadlineIds] }
          });
          resolve({ ...result.data, deadlines: [deadlineIds] });
        })
        .catch((err) => {
          dispatch({
            type: paymentConstants.REGISTER_TSPAY_DEADLINES_PAYMENT_ERROR,
            payload: err.toString()
          });
          reject(err);
        });
    });
  };
}
